// src/components/RouteChangeTracker.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logUserEvent } from '../services/logger';

function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    logUserEvent('page_view', 'route_change', location.pathname);
  }, [location]);

  return null;
}

export default RouteChangeTracker;
